angular.module("digitalLeasing.module").component("indexing", {
  templateUrl: "ng/components/digitalLeasing/financialData/indexing/indexing.view.html",
  bindings: {
    model: "=",
    callCalcolaCanone: "<",
    durata: "<",
    onIndexingChanges: "&",
    onCalcolaCanone: "&",
    tassoFixChange: "&",
    checkComponent: '&',
    snapshot: '<',
    endInfoTassi: "&",
    checkCalcCanoneTassoRun: "&",
    force: '='
  },
  controllerAs: "IndexingCtrl",
  controller: IndexingController
});

function IndexingController(
  $financialService,
  ModalitaCalcoloTasso,
  PianoFinanziario,
  $rootScope,
  $timeout,
  $modalService,
  $configService
) {
  var self = this;
  self.$rootScope = $rootScope;
  self.$onInit = function () {
    self.supportModel = {
      infoTassi: [],
      tassoSelezionato: {},
      calcoloTasso: [],
      tassoCalcolatoSelezionato: {
        tassoBase: null,
        tassoTrasferimento: null
      },
      oldVersTasso: $configService.getAppConfig().envData.oldVersTasso
    };
    if (!!!self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso) {
      self.dataTasso = moment().format("DD/MM/YYYY");
    } else {
      self.dataTasso = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso;
    }
    self.firstAccessInPageTasso = true;
    self.resumeInstanceForCalcolaTasso = true;
    self.firstInPage = true;
    var resumeInstance = false
    if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id &&
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.description) {
      self.supportModel.tassoSelezionato = self.model.leasingData.preventivo.pianoFinanziario.infoTassi;
      self.supportModel.tassoCalcolato = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0];
      self.supportModel.tassoCalcolatoSelezionato.tassoBase = self.supportModel.tassoCalcolato && self.supportModel.tassoCalcolato.tassoBase;
      self.supportModel.tassoCalcolatoSelezionato.tassoTrasferimento = self.supportModel.tassoCalcolato && self.supportModel.tassoCalcolato.tassoTrasferimento;
      resumeInstance = true;
    }
    var durata = self.model.leasingData.preventivo.pianoFinanziario.durataMesi ? self.model.leasingData.preventivo.pianoFinanziario.durataMesi : 0
    self.infoTassi(self.dataTasso, durata, resumeInstance);
    if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id == 'FIX') {
      $timeout(function () {
        self.disabledTassoBase = true;
      }, 3500)

    } else {
      self.disabledTassoBase = false;
    }
    checkPage();
  };

  self.$onChanges = function (changes) {
    if (changes.durata && changes.durata.currentValue) {
      self.infoTassi(self.dataTasso, changes.durata.currentValue);
    }

    if (changes.callCalcolaCanone && typeof changes.callCalcolaCanone.currentValue != 'undefined') {

      $timeout(function () {
        //if(!self.calcolaCanoneIsRunning || self.force){
        if (self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
          calcolaCanone();
        } else {
          calcolaTasso();
        }

        //}         
      }, 1)

    }
  }


  self.handleIndexingChange = function (property, value) {
    var tempTassoTrasferimento = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] &&
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento;
    if (property == "tassoSelezionato") {
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.isAdeguamento = false;
      if ((self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id != 'FIX' && value.tipoTasso.id == 'FIX') || (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id == 'FIX' && value.tipoTasso.id != 'FIX')) {
        self.supportModel.tassoCalcolato = "";
        self.supportModel.calcoloTasso = value.modalitaCalcoloTasso;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso = value.tipoTasso;
        var data = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice = value.indice;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataRilevazioneIndice = value.indice.dataRilevazioneIndice;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso = data;
        self.supportModel.tassoSelezionato = self.model.leasingData.preventivo.pianoFinanziario.infoTassi;
        self.waitEconomicConditionForCalcolaCanone = true;
        self.tassoFixSelezionato = true;
        self.infoTassi(self.dataTasso, self.model.leasingData.preventivo.pianoFinanziario.durataMesi, true, true);

      } else {
        self.waitEconomicConditionForCalcolaCanone = false;

        self.supportModel.tassoCalcolato = "";
        self.supportModel.calcoloTasso = value.modalitaCalcoloTasso;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso = value.tipoTasso;
        var data = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice = value.indice;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataRilevazioneIndice = value.indice.dataRilevazioneIndice;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso = data;
        self.supportModel.tassoSelezionato = self.model.leasingData.preventivo.pianoFinanziario.infoTassi;
      }
      var modalitaCalcolo = value.modalitaCalcoloTasso
        .find(function (e) {
          return e.modalitaDefault == true
        })

      self.handleIndexingChange("tassoCalcolato", modalitaCalcolo);
      self.supportModel.tassoCalcolato = modalitaCalcolo;
      if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id == 'FIX') {
        $timeout(function () {
          self.disabledTassoBase = true;
        }, 1000)

      } else {
        self.disabledTassoBase = false;
      }
      checkPage();
    }

    if (property == "tassoCalcolato") {
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.isAdeguamento = false;
      if (value && self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] && value.id == self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].id && value.tassoBase == self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase) {
        return;
      }
      console.log("Chiamata tasso calcolato")
      var indiceCollegato = self.supportModel.infoTassi.find(x => {
        return x.tipoTasso.id == self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id
      });
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice = indiceCollegato && indiceCollegato.indice;
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso = [];
      self.supportModel.tassoCalcolatoSelezionato = value;
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso.push(ModalitaCalcoloTasso.build(value));
      if (!self.waitEconomicConditionForCalcolaCanone) {
        if (self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
          calcolaCanone();
        } else {
          calcolaTasso();
        }
      } else {
        self.waitEconomicConditionForCalcolaCanone = false;
      }
      checkPage();
    }

    if (property == "rateBase") {
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase = value;
      if (!self.snapshot) {
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento = parseFloat((
          parseFloat(self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase) +
          parseFloat(self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.spreadTesoreria)).toFixed(4));
      }
      self.supportModel.tassoCalcolatoSelezionato.tassoTrasferimento = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento;

      if (tempTassoTrasferimento != self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento) {
        if (self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
          calcolaCanone();
        } else {
          calcolaTasso();
        }
        console.log("Chiamata rateBase")
      }
      checkPage();
    }

    if (property == "internalTransferRate") {
      if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == value) {
        return;
      }
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento = value;

      if (self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
        calcolaCanone();
      } else {
        calcolaTasso();
      }

      checkPage();
    }
    checkPage();
  };

  self.infoTassi = function (data, durata, resumeInstance, cambiaTassoFix) {

    if (self.snapshot) {
      return
    }

    var vecchioTasso = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id;
    var vecchiaModalitaCalcolo = self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] &&
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].id
    var cdAgevolazioni = self.model.leasingData.preventivo.agevolazioni
      .map(function (e) {
        return e.id
      })
    var cdConvenzionePlafond = self.model.leasingData.preventivo.convenzionePlafond && self.model.leasingData.preventivo.convenzionePlafond.cdConvenzione;
    $financialService.infoTassi(
      data,
      self.model.financialVendor.reteVendita.toString(),
      self.model.leasingData.preventivo.prodotto.id,
      self.model.leasingData.preventivo.convenzioni,
      durata,
      cdAgevolazioni,
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id,
      self.model.financialVendor.riUserG.ndg,
      cdConvenzionePlafond,
      self.model.leasingData.preventivo.listino.ndgListino,
      self.model.leasingData.preventivo.importo
    )
      .then(function (response) {
        console.log(response);
        response.infoTassi.forEach(function (element) {
          element.indice.dataRilevazioneIndice = moment(element.indice.dataRilevazioneIndice).format("DD/MM/YYYY")
        })
        self.supportModel.infoTassi = response.infoTassi;
        self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso = response.dataTasso;
        self.dataTasso = response.dataTasso;
        var modalitaCalcolo = {};
        var value = response.infoTassi
          .filter(function (e) {
            return e.tipoTasso.id == vecchioTasso;

          });
        var tassoDefault = response.infoTassi
          .find(function (t) {
            return t.selected == true
          })

        if (vecchiaModalitaCalcolo) {
          modalitaCalcolo = value && value[0] && value[0].modalitaCalcoloTasso
            .find(function (e) {
              return e.id == vecchiaModalitaCalcolo
            })
        } else {
          modalitaCalcolo = tassoDefault.modalitaCalcoloTasso
            .find(function (e) {
              return e.modalitaDefault == true
            })
        }
        var data = value[0] && value[0].indice && value[0].indice.dataRilevazioneIndice || 0;
        if (!resumeInstance) {
          self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataRilevazioneIndice = data;
          self.handleIndexingChange("tassoSelezionato", value[0] ? value[0] : (tassoDefault ? tassoDefault : response.infoTassi[0]));

          self.handleIndexingChange("tassoCalcolato", modalitaCalcolo);
          self.supportModel.tassoCalcolato = modalitaCalcolo;

        } else if (!cambiaTassoFix) {
          var temp = response.infoTassi.find(function (e) {
            return e.tipoTasso.id == self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id
          })
          self.supportModel.calcoloTasso = temp && temp.modalitaCalcoloTasso
        } else {
          var tassoSelezioanto = response.infoTassi.find(function (e) {
            return e.tipoTasso.description == self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.description
          })
          self.handleIndexingChange("tassoSelezionato", tassoSelezioanto);
        }
        if (response.infoTassi.length && !value.length && !modalitaCalcolo) {
          var modalitaCalcolo = tassoDefault.modalitaCalcoloTasso
            .find(function (e) {
              return e.modalitaDefault == true
            })
          self.handleIndexingChange("tassoSelezionato", tassoDefault ? tassoDefault : response.infoTassi[0]);

          self.handleIndexingChange("tassoCalcolato", modalitaCalcolo);
          self.supportModel.tassoCalcolato = modalitaCalcolo;
        }
        self.onIndexingChanges({
          tassi: response.infoTassi
        });
        if (self.firstInPage) {
          self.endInfoTassi();
          self.firstInPage = false;
        }
        if (self.tassoFixSelezionato) {
          self.tassoFixChange();
          self.tassoFixSelezionato = false;
        }
        if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id == 'FIX' && !cambiaTassoFix) {
          self.endInfoTassi();
        }

      })
      .catch(function (error) {
        console.log("Error:", error);
      })
  }

  self.callInfoTassi = function (test, value) {
    if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso != self.dataTasso && self.dataTasso && self.dataTasso.length == 10) {
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso = self.dataTasso;
      if (typeof self.dataTasso != 'undefined') {
        self.infoTassi(self.dataTasso, self.model.leasingData.preventivo.pianoFinanziario.durataMesi);
      }
    }
    checkPage();
  }

  var calcolaCanone = function () {
    if (self.snapshot) {
      return
    }
    self.calcolaCanoneIsEnded = false;
    checkPage();
    self.model.leasingData.preventivo.assicurazioni = self.model.leasingData.preventivo.assicurazioni
      .filter(function (e) {
        return e != ""
      })
    var checkAssicurazioni = self.model.leasingData.preventivo.assicurazioni
      .some(function (element) {
        return element.polizze[0].premi.importoPremioAttivo == null ||
          element.polizze[0].premi.importoPremioAttivo == "undefined"
      })
    if (!self.model.leasingData.preventivo ||
      !self.model.leasingData.preventivo.pianoFinanziario.durataMesi ||
      !self.model.leasingData.preventivo.pianoFinanziario.numeroRate ||
      self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
      (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == "MAXICANONE" &&
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo == null) ||
      typeof self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] == 'undefined' ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
      checkAssicurazioni ||
      (self.model.leasingData.preventivo.validations.fasceSpreadLordo.length == 0 && self.model.leasingData.preventivo.validations.fasceProvvigioni.length == 0) ||
      (self.model.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.model.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
      return;
    }
    self.calcolaCanoneIsRunning = true;
    self.checkCalcCanoneTassoRun({
      value: true
    });
    $financialService.calcolaCanone(self.model.leasingData.preventivo, self.model.financialVendor.reteVendita, self.model.financialVendor.mansioneAziendale, self.model.financialVendor.mansioni)
      .then(function (response) {
        if (response && response.pianoFinanziario && response.pianoFinanziario.canone) {
          self.model.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
          if (!response.pianoFinanziario.condizioniAggiuntive) {
            self.model.leasingData.preventivo.pianoFinanziario.condizioniAggiuntive = null;
          }
          self.model.leasingData.preventivo.validations.spreadNetto = response.validations.spreadNetto;
          self.model.leasingData.preventivo.validations.spreadNettoReale = response.validations.spreadNettoReale;
          self.onCalcolaCanone({
            response: response.pianoFinanziario
          });
        } else {
          self.onCalcolaCanone({
            response: self.model.leasingData.preventivo.pianoFinanziario
          });
        }
        self.calcolaCanoneIsEnded = true;
        $timeout(function () {
          self.calcolaCanoneIsRunning = false;

        }, 3000)

        checkPage();
        self.checkCalcCanoneTassoRun({
          value: false
        });
      })
      .catch(function (error) {
        self.checkCalcCanoneTassoRun({
          value: false
        });
        console.log(error);
        self.calcolaCanoneIsEnded = true;
        self.calcolaCanoneIsRunning = false;
        checkPage();
      })
  }

  var checkPage = function () {
    var test = !!(self.model.leasingData.preventivo.pianoFinanziario && self.model.leasingData.preventivo.pianoFinanziario.infoTassi && self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] && self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].id) &&
      typeof self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase != 'undefined' &&
      typeof self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento != 'undefined' &&
      typeof self.dataTasso != 'undefined' &&
      self.calcolaCanoneIsEnded


    if (test) {
      $timeout(function () {
        self.checkComponent({
          value: true
        })
      }, 5000);
    } else {
      self.checkComponent({
        value: false
      })
    }

  }
  var calcolaTasso = function () {
    if (self.snapshot) {
      return
    }
    self.calcolaCanoneIsEnded = false;
    checkPage();
    self.model.leasingData.preventivo.assicurazioni = self.model.leasingData.preventivo.assicurazioni
      .filter(function (e) {
        return e != ""
      })
    var checkAssicurazioni = self.model.leasingData.preventivo.assicurazioni
      .some(function (element) {
        return element.polizze[0].premi.importoPremioAttivo == null ||
          element.polizze[0].premi.importoPremioAttivo == "undefined"
      })
    if (!self.model.leasingData.preventivo ||
      !self.model.leasingData.preventivo.pianoFinanziario.durataMesi ||
      !self.model.leasingData.preventivo.pianoFinanziario.numeroRate ||
      self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo == null ||
      (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == "MAXICANONE" &&
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo == null) ||
      typeof self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] == 'undefined' ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoBase == null ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].tassoTrasferimento == null ||
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].description == null ||
      checkAssicurazioni ||
      (self.model.leasingData.preventivo.validations.fasceSpreadLordo.length == 0 && self.model.leasingData.preventivo.validations.fasceProvvigioni.length == 0) ||
      (self.model.leasingData.preventivo.pianoFinanziario.provvigioni.digitate && self.model.leasingData.preventivo.pianoFinanziario.provvigioni.importo == null)) {
      return;
    }
    self.calcolaCanoneIsRunning = true;
    self.checkCalcCanoneTassoRun({
      value: true
    });
    $financialService.calcolaTasso(self.model.leasingData.preventivo, self.model.financialVendor.reteVendita, self.model.financialVendor.mansioneAziendale, self.model.financialVendor.mansioni)
      .then(function (response) {
        if (response.message) {
          self.onCalcolaCanone({
            response: response.pianoFinanziario
          })
          self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadLordo = null;
          self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.spreadNetto = null;
          self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoMinimo = null;
          self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoEffettivo = null;
          self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoLeasing = null;
          self.checkCalcCanoneTassoRun({
            value: false
          });
          return;
        }
        self.onCalcolaCanone({
          response: response.pianoFinanziario
        })
        self.model.leasingData.preventivo.pianoFinanziario = PianoFinanziario.build(response.pianoFinanziario);
        if (!response.pianoFinanziario.condizioniAggiuntive) {
          self.model.leasingData.preventivo.pianoFinanziario.condizioniAggiuntive = null;
        }
        self.model.leasingData.preventivo.validations.spreadNetto = response.validations.spreadNetto;
        self.model.leasingData.preventivo.validations.spreadNettoReale = response.validations.spreadNettoReale;
        self.calcolaCanoneIsRunning = false;
        self.calcolaCanoneIsEnded = true;
        checkPage();
        self.checkCalcCanoneTassoRun({
          value: false
        });


      })
      .catch(function (error) {
        self.checkCalcCanoneTassoRun({
          value: false
        });
        console.log(error);
        self.calcolaCanoneIsEnded = true;
        self.calcolaCanoneIsRunning = false;
        checkPage();

      })
  }

  self.setData = function (value) {
    self.dataTasso = value;
    if (self.supportModel.oldVersTasso) {
      self.callInfoTassi();
    }
  }

  self.showValoriIndici = function () {
    self.restGetValoriIndiciCall = true;
    var durata = self.model.leasingData.preventivo.pianoFinanziario.durataMesi ? self.model.leasingData.preventivo.pianoFinanziario.durataMesi : 0
    var cdAgevolazioni = self.model.leasingData.preventivo.agevolazioni
      .map(function (e) {
        return e.id
      })
    var cdConvenzionePlafond = self.model.leasingData.preventivo.convenzionePlafond && self.model.leasingData.preventivo.convenzionePlafond.cdConvenzione;
    $financialService.getValoriIndici(
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice.dataTasso,
      self.model.financialVendor.reteVendita.toString(),
      self.model.leasingData.preventivo.prodotto.id,
      self.model.leasingData.preventivo.convenzioni,
      durata,
      cdAgevolazioni,
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id,
      self.model.financialVendor.riUserG.ndg,
      cdConvenzionePlafond,
      self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0].id
    )
      .then(function (response) {
        self.valoriIndici = response.indici.map(function (x, index) {
          Object.assign(x, { iesimo: index })
          return x
        });
        self.selected = null;
        $("#footerInstant").css("z-index", "-1");
        $(".financial-leasing__footer").css("z-index", "-1");
        $modalService.openModal('valoriIndici-modal');
        self.restGetValoriIndiciCall = false;
      })
      .catch(function (error) {
        console.log("Error:", error);

        self.restGetValoriIndiciCall = false;
      })
  }

  self.closedModal = function (value) {
    $modalService.closeModal(value);
  }

  self.select = function (index) {
    self.selected = self.valoriIndici[index];

  };

  self.doubleClick = function (index) {
    self.selected = self.valoriIndici[index];
    self.disableDoubleClick = true;
    self.confirmModal('valoriIndici-modal');
  }

  self.isRowSelected = function (index) {
    if (self.selected && self.valoriIndici[index].iesimo == self.selected.iesimo) {
      return true;
    }
    return false;
  };

  self.confirmModal = function (value) {
    self.disableDoubleClick = false;

    $modalService.closeModal(value);

    self.model.leasingData.preventivo.pianoFinanziario.infoTassi.indice = self.selected
    self.model.leasingData.preventivo.pianoFinanziario.infoTassi.modalitaCalcoloTasso[0] = self.selected.modalitaCalcoloTasso
    self.supportModel.tassoCalcolato = self.selected.modalitaCalcoloTasso;
    self.supportModel.tassoCalcolatoSelezionato = self.selected.modalitaCalcoloTasso;
    self.model.leasingData.preventivo.pianoFinanziario.infoTassi.isAdeguamento = true;
    self.supportModel.tassoSelezionato.indice = self.selected
    self.setData(self.selected.dataTasso);

    if (self.model.leasingData.preventivo.pianoFinanziario.tassiCalcolati.tassoOCanoneUtente != "C") {
      calcolaCanone();
    } else {
      calcolaTasso();
    }
  }
}